// The skapi MCP server. Used by the inbound MCP login hand-off allowlist in
// oauth.ts (isAllowedOAuthRedirect).
const isDev = (import.meta.env.VITE_MODE === "development");

export const MCP_BASE_URL = isDev ? 'https://mcp-dev.broadwayinc.computer' : 'https://mcp.broadwayinc.computer';
